import {
  Component, OnInit, Input, Output, OnChanges, EventEmitter,
  Directive, ViewContainerRef, ViewChildren, QueryList, ComponentFactoryResolver, AfterContentInit, ComponentRef
} from '@angular/core';
import { Subject } from 'rxjs';
import { BsModalService, ModalOptions, BsModalRef } from 'ngx-bootstrap';
@Component({
  selector: 'app-querycommentsmgt',
  templateUrl: './querycommentsmgt.component.html',
  styleUrls: ['./querycommentsmgt.component.css']
})
export class QuerycommentsmgtComponent implements OnInit {
  
  @Input() requestdetailid: number;
  @Input() requesttypeid: number;
  @Input() popupflag: number = 0;
  closeSubject: Subject<boolean> = new Subject();
  constructor(public bsModalRef: BsModalRef) { }

  ngOnInit() {
}

  close() {
    this.closeSubject.next(true);
    this.bsModalRef.hide();
  }
}
